/**
 * @module support/shared/widgets Date formating directive
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Directive, Input, OnInit, ElementRef, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Directive({
  selector: '[tmoDateFormatter]',
  providers: [DatePipe],
})
export class DateDirective implements OnInit, OnChanges {
  @Input() private date: Date;

  @Input() private format: string;

  @Input() private isMoment: boolean;

  constructor(
    private datePipe: DatePipe,
    private el: ElementRef
  ) {
    this.datePipe = datePipe;
    this.el = el;
  }

  /**
   * Initializes the data for currency directive.
   * @returns void
   */
  public ngOnInit(): void {
    this.dateFormatter();
  }

  /** On change of date, formats the date
   * @returns void
   */
  public ngOnChanges(): void {
    this.dateFormatter();
  }

  /**
   * Formats the date.
   * @returns void
   */
  private dateFormatter(): void {
    if (this.date) {
      const date = !this.isMoment
        ? this.datePipe.transform(this.date, this.format)
        : moment(this.date).format(this.format);
      this.el.nativeElement.innerText = date;
    }
  }
}
